// import coreRoutes from '@/core/router/routes'
import dcRoutes, { basePath as dcBasePath } from '@/connectors/router/routes'
import lhRoutes, { basePath as lhBasePath } from '@/lakehouse/router/routes'
import dpeRoutes, { basePath as dpeBasePath } from '@/dpe/router/routes'
import amRoutes, { basePath as amBasePath } from '@/qb/router/routes'
import ccRoutes, { basePath as ccBasePath } from '@/cc/router/routes'
import iamRoutes, { basePath as iamBasePath } from '@/iam/router/routes'
import appsRoutes, { basePath as appsBasePath } from '@/apps/router/routes'

// Making a shallow copy of routes in each services
const routes = {
  // core: { basePath: null, routes: [...coreRoutes] },
  dc: { basePath: dcBasePath, routes: [...dcRoutes] },
  lh: { basePath: lhBasePath, routes: [...lhRoutes] },
  dpe: { basePath: dpeBasePath, routes: [...dpeRoutes] },
  am: { basePath: amBasePath, routes: [...amRoutes] },
  cc: { basePath: ccBasePath, routes: [...ccRoutes] },
  iam: { basePath: iamBasePath, routes: [...iamRoutes] },
  apps: { basePath: appsBasePath, routes: [...appsRoutes] }
}

// for each services, filter only searchable routes
Object.keys(routes).forEach(key => {
  routes[key].routes = routes[key].routes.filter(r => r.searchable)
})

export default routes
